// extracted by mini-css-extract-plugin
module.exports = {"root":"m-complex__3jFUZlcv"};